export const BOOLEAN_3 = {

    "ANY": undefined,
    "TRUE": true,
    "FASLE": false
};